<template>
<m-pageframe
    title="Test Signature"
>
<v-container
    fluid
    v-if="meta_data != null"
>
    <div
        style="margin-left: 300px; margin-right: 300px; margin-top: 30px;"
    >
        <p><i>For Organization Admins</i></p>

        <h3>2026 Revised / Updated Agreements</h3>
        <p style="margin-top: 10px">We've updated our Subscription Agreement, Terms of Use, Privacy Policy, and related documents for 2026 to make them clearer, reflect new and upcoming RedChirp features and privacy safeguards.  This included changes to the Organization’s Obligations, arbitration agreement, class action waiver, and your compliance requirements.</p>
        <p>Please take a moment to review these updates before continuing to use our services.  Your continued use of our platform after the effective date means you agree to the new terms.</p>
        <p>You can view the updated documents anytime from the links below.</p>

        <v-list-item
            v-for="(item, index) in meta_data"
            :key="index"
        >
            <v-list-item-avatar
                v-on:click="$rc.openBlob(item.object_name);"
                style="cursor: pointer"
            > 
                <v-icon size="35" color="primary" style="padding: 0">mdi-file-pdf-box</v-icon>
            </v-list-item-avatar>

            <v-list-item-content
                v-on:click="$rc.openBlob(item.object_name);"
                style="cursor: pointer"
            >
                <v-list-item-title
                    style="text-decoration: underline; color: var(--v-primary-base);"
                >
                    {{item.label}}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-checkbox
            label="By checking this box, I affirm that I have read and agree to the above agreements and have full authority and approval to bind Barrel Creek Vineyards to the terms of the Organization Subscription Agreement."
        />

        <hr/>

        <p style="margin-top: 15px"><i>For Ordinary Users</i></p>

        <h3>2026 Revised / Updated Agreements</h3>
        <p style="margin-top: 10px">We've updated our Terms of Use, Privacy Policy, and related documents for 2026 to make them clearer, reflect new and upcoming RedChirp features and privacy safeguards.  This included changes to the arbitration agreement, class action waiver, and your compliance requirements.</p>
        <p>Please take a moment to review these updates before continuing to use our services.  Your continued use of our platform after the effective date means you agree to the new terms.</p>
        <p>You can view the updated documents anytime from the links below.</p>

        <v-list-item
            v-for="(item, index) in meta_data_ordinary_user"
            :key="index"
        >
            <v-list-item-avatar
                v-on:click="$rc.openBlob(item.object_name);"
                style="cursor: pointer"
            > 
                <v-icon size="35" color="primary" style="padding: 0">mdi-file-pdf-box</v-icon>
            </v-list-item-avatar>

            <v-list-item-content
                v-on:click="$rc.openBlob(item.object_name);"
                style="cursor: pointer"
            >
                <v-list-item-title
                    style="text-decoration: underline; color: var(--v-primary-base);"
                >
                    {{item.label}}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-checkbox
            label="By checking this box, I affirm that I have read and agree to the above agreements."
        />

        <div
            style="text-align: right"
        >
            <v-btn style="margin-right: 15px;">Remind me Later</v-btn>
            <v-btn color="primary">I Agree</v-btn>
        </div>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            meta_data: [
                { 'label': 'Authorized User Terms of Use (revised January 1st, 2026)' },
                { 'label': 'Authorized User Privacy Policy (revised January 1st, 2026)' },
                { 'label': 'Authorized User Agreement (revised January 1st, 2026)' },
                { 'label': 'Organization Subscription Agreement (revised January 1st, 2026)' }
            ],

            meta_data_ordinary_user: [
                { 'label': 'Authorized User Terms of Use (revised January 1st, 2026)' },
                { 'label': 'Authorized User Privacy Policy (revised January 1st, 2026)' },
                { 'label': 'Authorized User Agreement (revised January 1st, 2026)' }
            ],
        }
    },

    mounted () {
    },

    methods: {
    },
}
</script>

<style lang="scss" scoped>
</style>